import { render, staticRenderFns } from "./SubscriptionPlanSelector.vue?vue&type=template&id=5b6a1cba&scoped=true&"
import script from "./SubscriptionPlanSelector.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlanSelector.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPlanSelector.vue?vue&type=style&index=0&id=5b6a1cba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a1cba",
  null
  
)

export default component.exports